import '@fontsource/outfit/300.css';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/rubik/400.css';
import '@fontsource/rubik/600.css';
import '@fontsource/source-sans-3/400.css';
import '@fontsource/source-sans-3/700.css';

import siteBaseTheme from './siteBaseTheme';

const siteTypographyTheme = {
    typography: {
        base: {
            fontFamily: '"Source Sans 3", sans-serif',
            fontSizeMin: 14,
        },
        headings: {
            fontFamily: 'Outfit, sans-serif',
            fontSize: {
                h1: 30,
                h6: 15,
            },
            fontWeight: {
                h1: 500,
                h2: 300,
                h3: 300,
                h4: 400,
                h5: 500,
                h6: 500,
            },
            lineHeight: 1.15,
        },
        largeHeadings: {
            lineHeight: {
                h1: 1,
                h2: 1.15,
            },
        },
        strong: {
            fontWeight: 600,
        },
        colors: {
            dark: siteBaseTheme.base.colors.dark,
            light: siteBaseTheme.base.colors.light,
            muted: siteBaseTheme.base.colors.muted,
        },
    },
};

export default siteTypographyTheme;
